export default __webpack_public_path__ + "static/media/login_bg.8b68d69d.png";